/* global runtime */
// Access can be granted or revoked in PlummeAdmin while this app remains open.
// Revalidate through the backend when the tab becomes active; the browser-side
// membership mirror is not itself treated as proof of access.
let businessAccessRefreshPromise = null;

const refreshBusinessAccess = () => {
  if (!runtime.user || runtime.loading) return Promise.resolve(false);
  if (businessAccessRefreshPromise) return businessAccessRefreshPromise;

  const previousBusinessId = runtime.activeBusinessId;
  businessAccessRefreshPromise = (async () => {
    const refreshed = await loadBusinessAccess({ preserveOnError: true });
    if (!refreshed) return false;
    if (runtime.activeBusinessId !== previousBusinessId) {
      subscribeBusinessState();
    } else {
      emitRuntime();
    }
    return true;
  })().finally(() => {
    businessAccessRefreshPromise = null;
  });
  return businessAccessRefreshPromise;
};

const refreshAccessWhenActive = () => {
  if (document.visibilityState === 'hidden') return;
  void refreshBusinessAccess();
};

window.addEventListener('focus', refreshAccessWhenActive);
document.addEventListener('visibilitychange', refreshAccessWhenActive);
